import { Box, Stack, Typography } from "@mui/material"
import HomePageItemDisplay from "./HomePageItemDisplay"

export default function HomePagePreview({ data }: { data: any[] }) {
  return <Box sx={{
    p: 1, border: '1px solid gray', width: 300, overflow: 'auto', height: 600, borderRadius: 3,

  }}>
    {data?.map((i, index) => <Stack sx={
      {
        minHeight: '3rem', borderBottom: '1px solid gray', p: 1,
      }
    } key={index}>
      <Stack direction={"row"}>
        <Typography flexGrow={1} variant="caption" sx={{ opacity: .7 }}>{i.auto
          ? `[自动]${i.where?.channel || ''} ${i.where?.tags || ""} ${i.where?.keyword || ''} ${i.where?.length || 2}条`
          : `[手动]${i.item.length}条`}</Typography>
      </Stack>
      <HomePageItemDisplay value={i}></HomePageItemDisplay>
    </Stack>)}
  </Box>
}